<div>
  <h2
    mat-dialog-title
    style="color: white"
    class="title-text theme-background-color mb-4">
    Confirmation
  </h2>
  <mat-dialog-content class="mat-typography">
    <div class="row">
      <div class="col-md-12" style="position: relative; top: 14px; left: 10px">
        <div class="form-group">
          <p>{{ data.message }}</p>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions style="gap: 4px" class="flex-d" align="end">
    <button class="btn btn-secondary" [mat-dialog-close]="false">Cancel</button>
    <button class="btn btn-primary custom-button" [mat-dialog-close]="true">
      Confirm
    </button>
  </mat-dialog-actions>
</div>
